import { Stack, Typography, styled } from "@mui/material";
import { Link } from "react-router-dom";

const FooterContainer = styled(Stack)(({ theme }) => ({
  height: "100px",
  alignItems: "center",
  flexDirection: "row",
  justifyContent: "space-between",
  margin: "40px auto 0",
  width: "100%",
  padding: "0 160px",
  boxSizing: "border-box",
  overflowX: "hidden",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    m: 0,
    alignItems: "start",
    height: "auto",
    padding: "24px 18px 36px",
    overflowX: "hidden",
  },
}));

const FooterNav = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  marginTop: "0 !important",
  p: {
    margin: "0 !important",
  },
  a: {
    margin: "0 !important",
  },
  gap: "15px",
  [theme.breakpoints.down("sm")]: {
    gap: 0,
    flexWrap: "wrap",
    p: {
      "&:first-child": {
        flex: "100% 0 0",
      },
    },
  },
}));

const Separator = styled(Typography)(({ theme }) => ({
  color: "white",
  fontFamily: "Ubuntu",
  fontWeight: 500,
  position: "relative",
  display: "inline-block",

  "&::before": {
    content: '"|"',
    fontSize: 16,
    fontWeight: 500,
    transform: "scaleX(2)",
    display: "inline-block",
    width: "auto",
  },

  [theme.breakpoints.down("sm")]: {
    padding: "0 10px",
  },
}));

const FooterTextItem = styled(Typography)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: 16,
  fontWeight: 600,
  color: "white",
  marginBottom: "8px",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: 14,
    paddingBottom: "24px !important",
  },
}));

const FooterLinkTextItem = styled(Typography)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: 16,
  fontWeight: 700,
  color: "#81ba3f",
  marginBottom: "8px",
  "&:hover": {
    color: "white",
  },
  [theme.breakpoints.down("sm")]: {
    marginBottom: "12px",
  },
}));

const Footer = () => {
  return (
    <FooterContainer spacing={35} sx={{ backgroundColor: "black" }}>
      <FooterTextItem gutterBottom>
        Copyright © {new Date().getFullYear()} Impact - All Rights Reserved
      </FooterTextItem>
      <FooterNav spacing={8}>
        <Link
          to={"https://catacap.org/terms-conditions/"}
          style={{ textDecoration: "none" }}
        >
          <FooterLinkTextItem gutterBottom>
            Terms & Conditions
          </FooterLinkTextItem>
        </Link>
        <Separator gutterBottom></Separator>
        <Link
          to={"https://catacap.org/privacy-policy/"}
          style={{ textDecoration: "none" }}
        >
          <FooterLinkTextItem gutterBottom>Privacy Policy</FooterLinkTextItem>
        </Link>
      </FooterNav>
    </FooterContainer>
  );
};

export default Footer;
